// Copyright (c) 2016 Deere & Company

import Registration from '@deere/cps-it.warranty-model-factory/lib/registration';
import t from 'tcomb';

const Registrations = t.list(Registration, 'Registrations');

export const getDefaultState = () => new Registrations([]);

export default Registrations;



// WEBPACK FOOTER //
// ./src/product/registration-review/state/registrations.js